'use strict';

// Constructor
var Emergencycontacttakeover = function () {
    // Align the button text vertically
//    $('.button-text-wrapper').flexVerticalCenter();

    // Set the tabindex to -1 to prevent keyboard focus
    $('.emergency-contact-drop-down a').attr('tabindex', '-1');

    // Add aria attributes
    $('.emergency-contact-button').attr('aria-expanded', 'false');
    $('.emergency-contact-drop-down').attr('aria-hidden', 'true');

    // Clicking on the emergency contact button
    const $menu = $('#block-emergencycontacttakeover');
    $('.emergency-contact-button')
        .on('click', function ($event) {
            $event.preventDefault();
            // Open the dropdown
            $('.emergency-contact-drop-down').toggleClass('active');
            // Rotate the chevron
            $(this).toggleClass('active');
            // Make the contact-group boxes same height
            $('#block-emergencycontacttakeover .emergency-contact-drop-down .contact-group').matchHeight();
            $('.call-number').removeClass('call-number');

            // Toggle aria label
            $(this).hasClass('active') ? $(this).attr('aria-expanded', 'true') : $(this).attr('aria-expanded', 'false');
            $(this).hasClass('active') ? $('.emergency-contact-drop-down').attr('aria-hidden', 'false') : $('.emergency-contact-drop-down').attr('aria-hidden', 'true');
            $(this).hasClass('active') ? $('.emergency-contact-drop-down a').attr('tabindex', '0') : $('.emergency-contact-drop-down a').attr('tabindex', '-1');
        });
    $(document).on('mouseup', function (e) {
        if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
            $('.emergency-contact-drop-down').removeClass('active');
            $('.emergency-contact-button').removeClass('active');
        }
    });


    // Clicking on the phone number
    $('.emergency-contact-drop-down a').click(function ($event) {
        $event.preventDefault();
        $('.call-number').removeClass('call-number');
        $(this).addClass('call-number');

        if (!isMobileDevice()) {
            // If we are on desktop then just copy the text to clipboard
            // ** Pending ***
        } else {
            // Else open the phone 
            window.open($(this).attr('href'));
        }
    });

    // Focusing out of the previously clicked phone number
    /*
     $('.emergency-contact-drop-down a').focusout(function () {
     $('.call-number').removeClass('call-number');
     $('.emergency-contact-button').removeClass('active');
     $('.emergency-contact-drop-down').removeClass('active');
     $('.emergency-contact-button').removeClass('active');
     });
     
     // Clicking somewhere else other than the emmergency button
     $('.emergency-contact-button').focusout(function () {
     setTimeout(function () {
     if (!$('.call-number').length) {
     $('.emergency-contact-drop-down').removeClass('active');
     $('.emergency-contact-button').removeClass('active');
     }
     }, 100);
     });
     */

    // When typing on keyboard an pressing the ESC key
    $(document).keyup(function (e) {
        if (e.keyCode === 27) { // escape key maps to keycode `27`
            $('.emergency-contact-drop-down').removeClass('active');
            $('.emergency-contact-button').removeClass('active');
        }
    });

    // Simple function to check if is mobile device
    function isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }
    ;

};

module.exports = Emergencycontacttakeover;
